import { Scope } from '../../shared';

export const conversionGoals = {
  id: 'conversion-goals',
  name: _TL_('Conversion goals'),
  oldUIScope: [Scope.Account],
  children: [{
    id: 'conversion-goals',
    name: _TL_('Conversion goals'),
    route: 'conversiongoals',
  }],
};
